export default __webpack_public_path__ + "static/media/Automated-Data-Flow.1a2ab392.pdf";